import { Controller } from "@hotwired/stimulus"

// Stops a click from bubbling to its ancestors — used for the Edit link inside
// a <summary> so following it doesn't also toggle the <details>.
export default class extends Controller {
  stop(event) {
    event.stopPropagation()
  }
}
